import { render, staticRenderFns } from "./SummaryPersonalInformation.vue?vue&type=template&id=3c7a8621&scoped=true&"
import script from "./SummaryPersonalInformation.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummaryPersonalInformation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a8621",
  null
  
)

export default component.exports